import { set, toggle } from '@/utils/vuex';
import defaultState from "./state";

export default {
  resetState: state => state = Object.assign({}, defaultState),
  setList (state, response) {
    state.count = response.count
    if (!state.list) state.list = []
    state.list = state.list.concat(response.data)
  },
  setProject (state, project) {
    
    state.project = Object.assign(state.relation, project)
    console.log("setRelation", state.relation,project)
  },
  setContacts (state, contacts) {
    state.contacts = contacts
  },
};
